import { createContext, useState } from "react";
import { Outlet } from "react-router-dom";

export const SuperAdminOnboardingContext = createContext();

const SuperAdminOnboardingProvider = ({ children }) => {
  const [savedSuperAdminOnboardingSession, setSuperAdminOnboardingSession] =
    useState({});

  const values = {
    savedSuperAdminOnboardingSession,
    setSuperAdminOnboardingSession,
  };

  return (
    <SuperAdminOnboardingContext.Provider value={values}>
      <Outlet />
    </SuperAdminOnboardingContext.Provider>
  );
};

export default SuperAdminOnboardingProvider;
